import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { getTokenTimeRemaining } from '../tokenUtils';
import './TokenTimer.scss';

const TokenTimer = () => {
    const { token, isAuthenticated } = useAuth();
    const [timeRemaining, setTimeRemaining] = useState(null);

    useEffect(() => {
        if (!isAuthenticated || !token) {
            setTimeRemaining(null);
            return;
        }

        const updateTimer = () => {
            const remaining = getTokenTimeRemaining(token);
            setTimeRemaining(remaining);
        };

        // Update immediately
        updateTimer();

        // Update every second
        const interval = setInterval(updateTimer, 1000);

        return () => clearInterval(interval);
    }, [token, isAuthenticated]);

    if (!isAuthenticated || !timeRemaining) {
        return null;
    }

    const { expired, minutes, seconds } = timeRemaining;

    if (expired) {
        return null;
    }

    // Warning if less than 2 minutes
    const isWarning = timeRemaining.totalSeconds < 120;

    return (
        <div className={`token-timer ${isWarning ? 'warning' : ''}`} title="Bejelentkezés hátralévő ideje">
            <span className="timer-text">
                {minutes}:{seconds.toString().padStart(2, '0')}
            </span>
        </div>
    );
};

export default TokenTimer;
